import { styled } from '@mui/material/styles';
import { Stack } from 'components/ui';

export const AuthSelectionListRoot = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  width: '100%',
  '& [data-auth-selection-item="true"]': {
    textAlign: 'center',
  },
}));
